import { render } from "./DataTable.vue?vue&type=template&id=1dee4817"
import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dee4817"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dee4817', __exports__)) {
    api.reload('1dee4817', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=1dee4817", () => {
    api.rerender('1dee4817', render)
  })

}


export default __exports__